"use strict";
/**
 * Created by fan on 2/8/17.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var acts;
        (function (acts) {
            var universal;
            (function (universal) {
                var schema;
                (function (schema) {
                    var error;
                    (function (error) {
                        var TemplateNameEmptyError = /** @class */ (function (_super) {
                            __extends(TemplateNameEmptyError, _super);
                            function TemplateNameEmptyError() {
                                return _super.call(this, "Must give a template name.") || this;
                            }
                            return TemplateNameEmptyError;
                        }(Error));
                        error.TemplateNameEmptyError = TemplateNameEmptyError;
                        var TemplateTypeInvalidError = /** @class */ (function (_super) {
                            __extends(TemplateTypeInvalidError, _super);
                            function TemplateTypeInvalidError(type) {
                                return _super.call(this, "Invalid type, must be leaf or platform. Input: " + type) || this;
                            }
                            return TemplateTypeInvalidError;
                        }(Error));
                        error.TemplateTypeInvalidError = TemplateTypeInvalidError;
                        var TemplateNameMissMatchError = /** @class */ (function (_super) {
                            __extends(TemplateNameMissMatchError, _super);
                            function TemplateNameMissMatchError(key, val) {
                                return _super.call(this, "Miss matching template name.. Given: " + key + " and " + val) || this;
                            }
                            return TemplateNameMissMatchError;
                        }(Error));
                        error.TemplateNameMissMatchError = TemplateNameMissMatchError;
                        var TableNameEmptyError = /** @class */ (function (_super) {
                            __extends(TableNameEmptyError, _super);
                            function TableNameEmptyError() {
                                return _super.call(this, "Table must have a name.") || this;
                            }
                            return TableNameEmptyError;
                        }(Error));
                        error.TableNameEmptyError = TableNameEmptyError;
                        var TableCellFormatError = /** @class */ (function (_super) {
                            __extends(TableCellFormatError, _super);
                            function TableCellFormatError(tableName) {
                                return _super.call(this, "Invalid table cells format in " + tableName) || this;
                            }
                            return TableCellFormatError;
                        }(Error));
                        error.TableCellFormatError = TableCellFormatError;
                        var TableNameMissMatchError = /** @class */ (function (_super) {
                            __extends(TableNameMissMatchError, _super);
                            function TableNameMissMatchError(key, val) {
                                return _super.call(this, "Miss matching table name. Given: " + key + " and " + val) || this;
                            }
                            return TableNameMissMatchError;
                        }(Error));
                        error.TableNameMissMatchError = TableNameMissMatchError;
                        var NodeTypeAllFalseError = /** @class */ (function (_super) {
                            __extends(NodeTypeAllFalseError, _super);
                            function NodeTypeAllFalseError() {
                                return _super.call(this, "At least one type should be true.") || this;
                            }
                            return NodeTypeAllFalseError;
                        }(Error));
                        error.NodeTypeAllFalseError = NodeTypeAllFalseError;
                        var SpecNodeError = /** @class */ (function (_super) {
                            __extends(SpecNodeError, _super);
                            function SpecNodeError() {
                                return _super.call(this, "Must specify node id.") || this;
                            }
                            return SpecNodeError;
                        }(Error));
                        error.SpecNodeError = SpecNodeError;
                    })(error = schema.error || (schema.error = {}));
                })(schema = universal.schema || (universal.schema = {}));
            })(universal = acts.universal || (acts.universal = {}));
        })(acts = r6.acts || (r6.acts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.acts.universal.schema.error;
//# sourceMappingURL=schema-error.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/schema-builder/app/js/logic/schema-error.js